import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-picker" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_color_picker = _resolveComponent("color-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_color_picker, {
      pureColor: _ctx.pureColor,
      "onUpdate:pureColor": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pureColor) = $event)),
        _ctx.onPickerUpdate
      ],
      format: "hex",
      disableAlpha: true,
      lang: "en",
      shape: "circle",
      disableHistory: true
    }, null, 8, ["pureColor", "onUpdate:pureColor"]),
    _createElementVNode("span", { innerHTML: _ctx.pureColor }, null, 8, _hoisted_2)
  ]))
}